import React from "react";
import PropTypes from "prop-types";

// Components
import { Link } from "react-router-dom";
import { Table as AntTable } from "antd";

const Table = ({ tableProps, title, fullListLink, headerButtons }) => {
  const buildTableFooter = () => {
    if (!fullListLink) return null;
    return (
      <div className="table-footer">
        <Link className="see-full-list-btn" to={fullListLink}>
          See Full List
        </Link>
      </div>
    );
  };

  return (
    <div className="fulfillment-organization-table">
      <div className="header">
        <div className="title">{title}</div>
        <div className="add-button">{headerButtons}</div>
      </div>
      <AntTable
        className="data-table"
        {...tableProps}
        size="medium"
        pagination={false}
        footer={null}
        scroll={{ x: 800 }}
        rowKey={(r) => r.id}
      />
      {buildTableFooter()}
    </div>
  );
};

Table.propTypes = {
  tableProps: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  fullListLink: PropTypes.string,
  headerButtons: PropTypes.oneOfType([PropTypes.array, PropTypes.node]),
  navigationState: PropTypes.object,
};

export default Table;
